module.exports = __webpack_public_path__ + "img/ic-media.e5a452cc.svg";